import {
  createAlarmCentralAsync,
  deleteAlarmCentralByIdAsync,
  getAlarmCentralByIdAsync,
  getAllAlarmCentralEventByIdCountAsync,
  getAllAlarmCentralEventByLicenseCountAsync,
  getAllAlarmCentralsByLicenseAsync,
  getAllAlarmCentralsByLicenseCountAsync,
  updateAlarmCentralByIdAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateAlarmCentralAsync = () =>
  useMutation(createAlarmCentralAsync);

export const useGetAlarmCentralByIdAsync = () =>
  useMutation(getAlarmCentralByIdAsync);

export const useGetAllAlarmCentralsByLicenseAsync = () =>
  useMutation(getAllAlarmCentralsByLicenseAsync);

export const useUpdateAlarmCentralByIdAsync = () =>
  useMutation(updateAlarmCentralByIdAsync);

export const useDeleteAlarmCentralByIdAsync = () =>
  useMutation(deleteAlarmCentralByIdAsync);

export const useGetAllAlarmCentralEventByLicenseCountAsync = () =>
  useMutation(getAllAlarmCentralEventByLicenseCountAsync);

export const useGetAllAlarmCentralEventByIdCountAsync = () =>
  useMutation(getAllAlarmCentralEventByIdCountAsync);

export const useGetAllAlarmCentralsByLicenseCountAsync = () =>
  useMutation(getAllAlarmCentralsByLicenseCountAsync);
